export default function () {
  const btns = Array.prototype.slice.call(document.querySelectorAll("button[data-toggle-section]"));

  const openPanel = (section: HTMLElement) => {
    section.classList.add("_open");
    if (window.innerWidth < 768) {
      section.scrollIntoView();
      section.style.maxHeight = "1100px";
      setTimeout(() => (section.style.maxHeight = "none"), 100);
    } else {
      section.style.maxHeight = "800px";
    }
  };
  const closePanel = (section: HTMLElement) => {
    section.classList.remove("_open");
    if (window.innerWidth < 768) {
      section.style.maxHeight = "1100px";
      setTimeout(() => (section.style.maxHeight = "0px"), 100);
    } else {
      section.style.maxHeight = "0px";
    }
  };
  for (const btn of btns) {
    btn.addEventListener("click", () => {
      const id = btn.dataset.toggleSection;
      const section = document.getElementById(id);
      if (!section) return;
      if (section.classList.contains("_open")) {
        closePanel(section);
      } else {
        openPanel(section);
      }
    });
  }
}
